import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import Apis from '@/Apis/_'

interface ILogs {
  dataTetativa: string
  ehGestor: boolean
  ehProfissionalExecutante: boolean
  erroMensagem: string | null
  id: number
  sucesso: boolean
}

interface IUsuario {
  ativo: boolean
  clienteFinX: string
  cpf: string
  dataCadastro: string
  dataDesativacao: string
  email: string
  logsLiberacao: ILogs[]
  nome: string
  perfil: string
  statusCadastro: string
  userId: number
}

interface IUsuariosResponse {
  itens: IUsuario[]
  paginaAtual: number
  qtdPorPagina: number
  totalPaginas: number
  totalRegistros: number
}

@Module({ namespaced: true, name: 'SuporteUsuariosRemuneracaoStore' })
export default class SuporteUsuariosRemuneracaoStore extends VuexModule {
  usuarios: any[] = []
  logs: any[] = []
  showModalLogs: boolean = false
  drawer: boolean = false
  filtroNome: string = ''
  filtroCpf: string = ''
  filtroEmail: string = ''
  filterLoading: boolean = false

  public pagination: any = {
    descending: false,
    page: 1,
    rowsPerPage: 10,
    sortBy: null,
    totalItems: null
  }

  @Mutation
  setUsuarios(usuarios: IUsuario[]) {
    this.usuarios = usuarios
  }

  @Mutation
  setLogs(logs: ILogs[]) {
    this.logs = logs
  }

  @Mutation
  setShowModalLogs(show: boolean) {
    this.showModalLogs = show
  }

  @Mutation
  setPagination(pagination: any) {
    this.pagination = pagination
  }

  @Mutation
  setPage(page: number) {
    this.pagination.page = page
  }

  @Mutation
  setDrawer(drawer: boolean) {
    this.drawer = drawer
  }

  @Mutation
  setFiltroNome(nome: string) {
    this.filtroNome = nome
  }

  @Mutation
  setFiltroCpf(cpf: string) {
    this.filtroCpf = cpf
  }

  @Mutation
  setFiltroEmail(email: string) {
    this.filtroEmail = email
  }

  @Mutation
  setFilterLoading(loading: boolean) {
    this.filterLoading = loading
  }

  @Mutation
  clearFilters() {
    this.filtroNome = ''
    this.filtroCpf = ''
    this.filtroEmail = ''
  }

  @Action
  async getUsuarios() {
    const params = {
      pagina: this.pagination.page,
      qtdPorPagina: this.pagination.rowsPerPage,
      nome: this.filtroNome,
      cpf: this.filtroCpf,
      email: this.filtroEmail,
    }

    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getUsuarios(params)
    if (response.success) {
      this.context.commit('setUsuarios', response.data.itens)
      this.context.commit('setPagination', { page: response.data.paginaAtual, rowsPerPage: response.data.qtdPorPagina, totalItems: response.data.totalRegistros })
    }
    return response
  }
}